<template>
  <div class="login_bg">
     <img src="../assets/image/login/smallWeiTu.png" class="login_small_image"/>
    <span class="login_title_span">口袋零钱</span>
    <div class="tab_box">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="首页" name="index1"></el-tab-pane>
        <el-tab-pane label="企业服务" name="businessServices" ></el-tab-pane>
        <el-tab-pane label="关于我们" name="aboutUs"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="login_box_bg">
       <span class="reg_hint_span">还没有账号？</span>
       <button class="reg_button">注册</button>
      <img src="../assets/image/login/mianBan.png" class="blue_small_image"/>
      <span class="pocket_change_span">口袋零钱</span>
      <span class="account_number_span" >账号</span>
      <input type="text" class="account_number_input" v-model="userNum">
      <span class="pwd_span">密码</span>
<!--      <input type="password" class="pwd_input">-->
      <el-input v-model="userPwd"   class="pwd_input" show-password></el-input>
<!--      <img src="../assets/image/login/Checkbox.png" class="cheched_one"/>-->
<!--      <span class="remember_pwd_span">记住密码</span>-->
      <el-checkbox v-model="checked" class="cheched_one">记住密码</el-checkbox>
      <a class="forgrt_pwd_a" href="" alt="">忘记密码?</a>
      <button class="login_btn" @click="loginFun()">登录</button>
    </div>

  </div>
</template>

<script>
import {getData} from '../../static/js/axios'
export default {
  name: "login",
  data(){
    return{
      activeName:'index1',
      checked:false,
      userPwd:'',
      userNum:''
    }
  },
  methods:{
    handleClick(tab) {
      // this.$router.push(tab.paneName)
      console.log(tab);
    },
    loginFun(){
      let that = this;
      var userNum=that.userNum;
      var userPwd=that.userPwd;
      console.log(userNum,userPwd);
      params.append('username',that.userNum);
      params.append('password',that.userPwd);
      getData("/api/position/all",'post',params).then(res =>{
        if(res.data.success){
          console.log(res.data.data)
          this.recruitArr=res.data.data;
        }
      },(err)=>{})
    }
  }
}
</script>

<style>
*{
  padding: 0;
  margin: 0;
  border: 0;
}
.login_bg{
  width: 100%;
  min-height: 1080px;
  background-image: url("../assets/image/login/bg.png");
  background-repeat: no-repeat;
}
.login_small_image{
  margin-left: 8.125rem;
  margin-top: 5.875rem;
}
.login_title_span{
  font-size: 28px;
  font-family: Medium;
  color: #FFFFFF;
  display: block;
  margin-top: -41px;
  margin-left: 180px;
}
/*.van-tab{*/
/*  display: inline-block;*/
/*}*/
/*.van-tabs__line{*/
/*  width: 60px;*/
/*  height: 6px;*/
/*  background-color:#006CD1;*/
/*  transform: translateX(53.5px) translateX(-50%);*/
/*  border-radius: 2px;*/
/*  transition-duration: 0.3s;*/
/*  margin-left: -1189px;*/
/*}*/
/*.van-tab__text{*/
/*  font-size: 18px;*/
/*  color: #FFFFFF;*/
/*  margin-left: 100px;*/
/*}*/
/*.tab_box{*/
/*  width: 34%;*/
/*  height: 100px;*/
/*  margin-left: 1240px;*/
/*  margin-top: -28px;*/
/*}*/
.login_box_bg{
  width: 1668px;
  height: 818px;
  margin-left: 130px;
  margin-top: -37px;
  /*border: 1px solid black;*/
  background-image: url("../assets/image/login/bianZu.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
}
.reg_hint_span{
  font-size: 20px;
  color: #999999;
  font-family: Regular;
  margin-left: 1315px;
  /*line-height: 62px;*/
  display: inline-block;
  margin-top: 62px;
}
.reg_button{
  width: 140px;
  height: 50px;
  border-radius: 36px;
  border: 0.5px solid #0729BF;
  color: #0729BF;
  background-color: white;
  margin-left: 7px;
}
.blue_small_image{
  margin-top: 59px;
  margin-left: 937px;
}
.pocket_change_span{
  font-size: 24px;
  color: #333333;
  font-weight: bold;
  display: block;
  margin-left: 989px;
  margin-top: -41px;
}
.account_number_span{
  font-size: 20px;
  color: #333333;
  font-family: Regular;
  display: block;
  margin-left: 936px;
  margin-top: 45px;
}
.account_number_input{
  width: 656px;
  height: 72px;
  border: 0.5px solid #DAE0F2;
  border-radius: 5.33px;
  margin-left: 936px;
  font-size: 20px;
}
.pwd_span{
  font-size: 20px;
  color: #333333;
  font-family: Regular;
  display: block;
  margin-left: 936px;
  margin-top: 47px;

}
.pwd_input{
  width: 656px;
  height: 72px;
  border: 0.5px solid #DAE0F2;
  border-radius: 5.33px;
  margin-left: 936px;
  font-size: 20px;
}

.el-input__inner {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  height: 72px;
  line-height: 72px;
  outline: none;
  padding: 0 15px;
  transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  width: 656px;
}

.cheched_one{
  margin-left: 936px;
  margin-top: 28px;
}
.remember_pwd_span{
  font-size: 20px;
  color: #333333;
  font-family: Regular;
  display: block;
  margin-top: -34px;
  margin-left: 979px;
}
.forgrt_pwd_a{
  font-size: 20px;
  color: #333333;
  text-decoration: none;
  display: block;
  margin-left: 1500px;
  margin-top: -26px;
}
.login_btn{
  width: 360px;
  height: 60px;
  background-color: #0729BF;
  border-radius: 30px;
  border: none;
  color: white;
  margin-left: 1074px;
  margin-top: 55px;
}

/*去除标签页下的线*/
.el-tabs__nav-wrap:after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 2px;
  background-color: transparent;
  z-index: 1;
}
/*修改复选框字体大小*/
.el-checkbox__label {
  display: inline-block;
  padding-left: 10px;
  line-height: 19px;
  font-size: 20px;
}
/*修改复选框大小*/
.el-checkbox__inner {
  width: 20px;
  height: 20px;
}
/*修改钩大小*/
.el-checkbox__inner::after {
  height: 10px;
  left: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue